<template>
  <h2 class="mb-2 text-sm font-normal text-gray-400">
    <slot />
  </h2>
</template>
